<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">
              mdi-arrow-left
            </v-icon>
            {{ $t('login_as_guest') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <v-form class="py-12 px-2">
            <ValidationProvider v-slot="{ errors, valid }" name="name" rules="required">
              <v-text-field v-model="form.guest_name" outlined dense :label="$t('name')" color="primary" :error-messages="errors" />
            </ValidationProvider>
            <l-a-phone-number v-model="form.guest_phone" :label="$t('fields.phone')" />
            <v-btn color="primary" x-large block class="text-none mt-4" @click="loginAsGuest()">
              {{ $t('next_2') }}
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  login as loginCustomer
} from '@/api/auth'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import LAPhoneNumber from '@/components/modules/LAphone/Index'
export default {
  components: {
    LAPhoneNumber,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      form: {
        is_guest: 1,
        guest_name: '',
        guest_phone: ''
      }
    }
  },
  methods: {
    async loginAsGuest() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          const { data } = await loginCustomer(this.form)
          this.$store.state.loading_axios = false
          this.$store.dispatch('save_token', data)
          const query = this.$route.query.redirect
          if (query) {
            if (query === 'order') {
              this.$router.push({ name: query, params: { id: this.$route.query.id }}).catch(() => {})
            } else if (query === 'reservation_place' && this.$route.query.date) {
              this.$router.push({ name: query, query: { date: this.$route.query.date }}).catch(() => {})
            } else {
              this.$router.push({ name: query }).catch(() => {})
            }
          } else {
            const astra_outlet = this.$store.state.store_astra
            const tmii_outlet = this.$store.state.store_tmii
            const url_id = this.$store.state.url_domain

            if (tmii_outlet.indexOf(url_id) !== -1) {
              window.location.href = 'https://order.kulinertmii.id'
            } else if (astra_outlet.indexOf(url_id) !== -1) {
              window.location.href = 'https://zestloungemenaraastra.myolsera.com'
            } else {
              this.$router.push({ name: 'home' }).catch(() => {})
            }
          }
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    goBack() {
      if (this.$store.state.router_from.name === 'payment' || this.$router.currentRoute.query.redirect === 'payment' || this.$store.state.router_from.name === 'checkout' || this.$router.currentRoute.query.redirect === 'checkout') {
        this.$router.push({ name: 'login', query: { redirect: 'checkout' }}).catch(() => {})
      } else {
        this.$router.push({ name: 'login' }).catch(() => {})
      }
    }
  }
}
</script>
